import req from "../http";

const interview = {
  // 批次取得 面談成績
  getScores(params) {
    return req("post", "/Recruitment/Interview/GetScores", params);
  },

  // 批次更新 面談成績
  putScores(params) {
    return req("put", "/Recruitment/Interview/Scores", params);
  },
};

export default interview;